"use strict";

exports.__esModule = true;
exports["default"] = lruCache;

function lruCache(limit, equals) {
  var entries = [];

  function get(key) {
    for (var index = 0; index < entries.length; index++) {
      var entry = entries[index];
      if (equals(key, entry.key)) {
        if (index > 0) {
          // move this entry to the top of the cache
          entries.splice(index, 1);
          entries.unshift(entry);
        }
        return entry.value;
      }
    }
  }

  function put(key, value) {
    if (!get(key)) {
      entries.unshift({ key: key, value: value });
      if (entries.length > limit) {
        entries.pop();
      }
    }
  }

  return { get: get, put: put };
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/lru-memoize/lib/lruCache.js
// module id = 900
// module chunks = 0